export default "__VITE_ASSET__BrJZU1jV__"